import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import flush from 'just-flush'

import { MenuFilters } from '@/ducks/menu/menu.types'

import { MenuMainCategory } from '../api/menu.api.types'

export interface IMenuDataEntry {
  name?: string
  category?: string
  sub_category?: string
  image?: string
  description?: string
  price?: string
  supplier_id?: string
  sku?: string
  short_description?: string
  zone?: string
  shelf?: string
  level?: number
  // code?: string
  purchase_price?: string
  barcode?: string
  quantity?: number
  lot?: string
  expiration_date?: string
  quantity_minimum?: number
}

export interface MenuSliceState {
  filters: MenuFilters
}

export interface Menu {
  menu: {
    mainCategories: MenuMainCategory[]
  }
}
const initialState: MenuSliceState = {
  filters: {}
}

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setMenuFilters: (state, action: PayloadAction<MenuFilters>) => {
      const { mainCategories } = action.payload
      const clearedFilters = flush({
        ...action.payload,
        ...(mainCategories?.length !== 0
          ? { mainCategories }
          : { mainCategories: undefined })
      })
      state.filters = { ...clearedFilters }
    }
  }
})

export const { setMenuFilters } = menuSlice.actions

export default menuSlice.reducer
